/**
 * Messages browsers produce when a code-split chunk cannot be fetched — after a
 * deploy rotated the hashed filenames, or while offline. One pattern per
 * engine, plus Vite's own CSS-preload failure.
 */
export const CHUNK_LOAD_ERROR_PATTERNS: readonly RegExp[] = [
  /Failed to fetch dynamically imported module/, // Chromium
  /Importing a module script failed/, // WebKit
  /error loading dynamically imported module/i, // Gecko
  /Unable to preload CSS/, // Vite preload helper
];

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}
